import "./About.css";
import Hero from "../../components/Hero/Hero";
import Footer from "../../components/Footer/Footer";
import Aboutus from "../../components/Aboutus/Aboutus";
const AboutImg =
  "https://images.unsplash.com/photo-1514923995763-768e52f5af87?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1074&q=80";

function About() {
  return (
    <div>
      <Hero cName="hero-mid" heroImg={AboutImg} title="About" />
      <Aboutus />
      <Footer />
    </div>
  );
}

export default About;
